export default "__VITE_ASSET__U9oHZyu2__"